// extracted by mini-css-extract-plugin
export default {"loadMoreBtn":"Button_loadMoreBtn__bhrx+"};